module.exports = __webpack_public_path__ + "img/tk-icon.a923a991.svg";